import {connect} from "redux-vue";
import classNames from 'classnames';
import * as moduleActions from "../actions/module";
import LoadingIndicator from "./LoadingIndicator";

const ModuleCard = {
  /**
   *
   */
  props: ["user", "modelProp", "setModule", "enrollModule", "module", "highlight"],

  /**
   *
   */
  methods: {
    onPressDetails(e) {
      e.preventDefault();
      this.setModule(this.modelProp);
      this.$router.push({name: 'QuickviewModal', params: {id: this.modelProp.id}});
    },
    onPressEnroll () {
      const isAuthorized = !!(this.user.token && this.user.model);
      if (!isAuthorized) {
        this.$router.push({name: 'RegisterModal'});
      } else {
        const hasActivity = (this.modelProp.lessons || []).some(lesson => !!lesson.activities.length);
        if (hasActivity) {
          this.enrollModule(this.modelProp);
        } else {
          Snackbar.show({
            text: this.$t('courses_page.module_available_soon'),
            actionText: this.$t('dismiss'),
          });
        }
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const mobileClass = classNames(
      "mdi text-teal-800 text-sm lg:text-base",
      this.modelProp.mobile ? 'mdi-cellphone' : 'mdi-cellphone-off opacity-25'
    );
    const desktopClass = classNames(
      "mdi text-teal-800 text-sm lg:text-base",
      this.modelProp.desktop ? 'mdi-laptop' : 'mdi-laptop-off opacity-25'
    );
    const highlight = this.highlight || "";
    const filterRegEx = new RegExp(highlight, "gi");
    const replaceFn = string => {
      return `<span class="bg-yellow-400">${string}</span>`
    };
    return (
      <div class="bg-white shadow rounded overflow-hidden h-full pb-2">
                  {this.modelProp.sequence > 15 && <div class="bg-theme_green h-3"></div>}
                    <div class="flex flex-col h-full">
                      <div class="p-3 text-gray-600 flex-1">
                        {this.modelProp.sequence < 16 && <p class="text-xs mb-5">
                          {this.$t('courses_page.course_sequence', {sequence: this.modelProp.sequence})}
                        </p>}
                        <h3 class="font-bold text-xl mb-5" domPropsInnerHTML={highlight.length > 1
                          ? this.modelProp.name.replace(filterRegEx, replaceFn)
                          : this.modelProp.name}>
                        </h3>
              
                        <p domPropsInnerHTML={highlight.length > 1
                          ? this.modelProp.description.replace(filterRegEx, replaceFn)
                          : this.modelProp.description}>
                        </p>
                      </div>
                      <div class="bg-gray-100">
                        <div class="flex items-center justify-between p-3">
                          <div class="flex flex-col">
                            <a href={`/courses/${this.modelProp.id}/quickview`} disabled={this.module.enroll || this.masterEnroll}
                                         class="focus:outline-none text-blue-500 hover:underline text-xs"
                                         onClick={this.onPressDetails}
                            >
                              {this.$t('courses_page.view_details')}
                              <i class="mdi mdi-open-in-new ml-1"></i>
                            </a>
                            <p class="text-xs text-gray-600">
                              {this.$t('courses_page.est_time', {time: this.modelProp.estimated_time})}
                            </p>
                          </div>
                          <button onClick={this.onPressEnroll}
                            class="px-3 p-2 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline"
                            type="button" disabled={this.module.enroll || this.masterEnroll}>
                            {this.module.enroll && this.module.model.id === this.modelProp.id
                              ? <LoadingIndicator/>
                              : (
                                <fragment>
                                  <i class="mdi mdi-plus mr-2"></i>
                                  {this.$t('courses_page.enroll')}
                                </fragment>
                              )
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    module: state.module,
  };
}

function mapActionToProps(dispatch) {
  return {
    setModule: module => dispatch(moduleActions.setModule(module)),
    enrollModule: async module => await dispatch(moduleActions.enrollModule(module))
  };
}

export default connect(mapStateToProps, mapActionToProps)(ModuleCard);
